import { sanitizeVendorBranding } from './sanitizeVendorBranding'

/**
 * Card / modal titles for AML hits (watchlist screening vs reference database).
 */

export function getMatchCardHeadline(match) {
  if (!match) return 'Match'
  if (match.cardHeadline) return sanitizeVendorBranding(match.cardHeadline)
  if (match.matchKind === 'person') {
    return sanitizeVendorBranding(match.primaryName || match.name || 'Match')
  }
  return sanitizeVendorBranding(match.displayTitle || match.primaryName || match.name || 'Match')
}

export function getMatchCardSubtitle(match) {
  if (!match) return null
  if (match.cardSubtitle) return sanitizeVendorBranding(match.cardSubtitle)
  if (match.matchKind === 'person') return match.riskDescription || null
  if (match.matchKind === 'media_article') return match.displayTitle || null
  return match.detailKindLabel || null
}

export function getMatchDetailTitle(match) {
  if (!match) return 'Match details'
  return sanitizeVendorBranding(match.detailTitle || getMatchCardHeadline(match))
}

export function isWatchlistAmlScreening(match, provider) {
  const p = (provider || match?.screeningProvider || '').toLowerCase()
  return p === 'greenid' || p === 'watchlist'
}

/** @deprecated use isWatchlistAmlScreening */
export const isGreenIdMatch = isWatchlistAmlScreening
